<template>
  <div class="event-item" :class="{'noTransition' : isNoTrans, 'clear-both' : isClear}">
    <div class="event-item-custom-message" @click="openModal()" v-if="isEM" v-b-tooltip.hover.bottom :title="'More details'">
      <div class="event-item-custom-message-icon icon-gear"></div>
    </div>
    <div @click="deleteClientClick()" v-b-tooltip.hover.bottom :title="'Delete'" class="delete-client-button" v-if="isAdminRole()">
      <div class="icon-delete"></div>
    </div>
    <div class="event-item-header">
      <div class="wrapper-event-item-name">
        <div @click="gotoUserView()" class="event-item-name">
          <span >{{ client.clientName }}</span>
        </div>
      </div>
      <div v-if="!isClientManager()" class="event-item-role">
        <div class="event-manager">
          <b-form-group vertical
                        class="ap-dropdown">
            <b-dropdown class="ap-dropdown-btn" no-caret v-modal="client.eventManagerId" :disabled="!(isEventManager() || isAdminRole())">
              <template slot="button-content">
                <div class="button-content">
                  <div class="text" :class="{active: emName != ''}">{{client.eventManagerName || 'Choose EM'}}</div>
                </div>
              </template>
              <div class="ap-dropdown-menu">
                <b-dropdown-item class="ap-dropdown-item" v-for="item in listEM" :value="item.id"
                                 :key="item" @click="dropdownItemClick(item)">
                  <div class="ap-item-wrapper">
                    <div class="ap-item-content">{{item.firstName + ' ' + item.lastName}}</div>
                  </div>
                </b-dropdown-item>
              </div>
            </b-dropdown>
          </b-form-group>
        </div>
        <div class="event-item-role-text-am custom-multiselect">
          <multiselect :options="listAM"
                       label="name"
                       placeholder="Choose AM"
                       @input="selectAm"
                       v-model="selectedAm"
                       class="multiple-select-am"
                       :show-no-results="false"
                       :allow-empty="false"
                       :show-labels="false"
                       :max-height="100"
                       :disabled="!(isEventManager() || isAdminRole())"></multiselect>
        </div>
      </div>
    </div>
    <ClientCardFooter :client="client"></ClientCardFooter>
  </div>
</template>

<script>
  import 'vue-awesome/icons/pencil';
  import 'vue-awesome/icons/cog';
  import Multiselect from 'vue-multiselect';
  import ClientCardFooter from './ClientCardFooter';
  import Icon from 'vue-awesome/components/Icon';
  import consts from '../../_consts';
  import routerConstanst from '@/router/constants';
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'client-card',
    components: {
      ClientCardFooter,
      Icon,
      Multiselect
    },
    props: {
      client: {
        type: Object,
        default: {}
      },
      isNoTrans: {
        type: Boolean,
        default: false
      },
      isClear: {
        type: Boolean,
        default: false
      },
      listEM: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    data () {
      return {
        roleIcon: consts.iconNames.pencil,
        selectedAm: {},
        listEM: [],
        emName: ''
      };
    },
    methods: {
      gotoUserView () {
        localStorage.setItem(consts.LOCAL_STORE.clientId, this.client.id);
        localStorage.setItem(consts.LOCAL_STORE.clientName, this.client.clientName);
        localStorage.setItem(consts.LOCAL_STORE.addOns, this.client.addOns);
        localStorage.setItem(consts.LOCAL_STORE.readOnly, this.client.userManageReadOnly);
        this.updateClientName(this.client.clientName);
        this.$router.push({
          name: routerConstanst.clientDashboard.name,
          params: {
            clientId: this.client.id
          }
        });
      },
      isEventManager () {
        return localStorage.getItem(consts.LOCAL_STORE.role) === consts.USER_ROLE.eventManager;
      },
      isAdminRole () {
        return localStorage.getItem(consts.LOCAL_STORE.role) === consts.USER_ROLE.admin;
      },
      isClientManager () {
        return localStorage.getItem(consts.LOCAL_STORE.role) === consts.USER_ROLE.clientManager;
      },
      selectAm (item) {
        if (item !== null) {
          // update AM for client
          this.selectedAm = item;
          let client = {
            clientId: this.client.id,
            clientName: this.client.clientName,
            userId: this.selectedAm.id,
            eventManagerName: this.client.eventManagerName
          };
          this.updateClient(client); // @param clientId, Event Manager Name, Account managerID
        }
      },
      eventManagerNameChange () {
        let client = {
          clientId: this.client.id,
          clientName: this.client.clientName,
          userId: this.selectedAm.id,
          eventManagerName: this.client.eventManagerName
        };
        this.updateClient(client)
      },
      openModal () {
        this.$modal.show('customMessageModal', this.client.id);
      },
      deleteClientClick () {
        let modalData = {
          action: consts.modalAction.deleteClient,
          data: this.client
        };
        this.$modal.show('eventModal', modalData);
      },
      dropdownItemClick (item) {
        this.client = {
          ...this.client,
          clientId: this.client.id,
          eventManagerId: item.id,
          eventManagerName: item.firstName + ' ' + item.lastName
        };
        this.updateClient(this.client);
      },
      ...mapActions({
        updateClient: 'ACTION_UPDATE_CLIENT',
        updateClientName: 'ACTION_UPDATE_CLIENT_NAME',
        deleteClientApi: 'ACTION_DELETE_CLIENT'
      })
    },
    computed: {
      isEM () {
        return localStorage.getItem(consts.LOCAL_STORE.role) === consts.USER_ROLE.eventManager || localStorage.getItem(consts.LOCAL_STORE.role) === consts.USER_ROLE.admin;
      },
      ...mapGetters({
        getListAM: 'GETTERS_GET_LIST_AM'
      }),
      listAM () {
        return this.getListAM;
      },
      getEMName () {
        return this.listEM.find()
      }
    },
    mounted: function () {
      this.selectedAm = {
        id: this.client.managedBy,
        name: this.client.managerName
      };
    }
  };
</script>


// WEBPACK FOOTER //
// ClientCard.vue?75b556a9